import React from 'react'
import ActionToggle from 'live/components/ui/action-toggle'

interface Props {
    value: boolean
    onChange: (value: boolean) => void
    label: string
}

export function Flag({ value, onChange, label }: Props): JSX.Element {
    return (
        <div>
            <ActionToggle active={value} onChange={() => onChange(!value)} />
            {label}
        </div>
    )
}
